import {
  LogLevel,
  BrowserCacheLocation,
} from "@azure/msal-browser";
import { getRuntimeConfig } from '../runtime-config';

// Get runtime configuration
const config = getRuntimeConfig();
const VITE_API_APPLICATION_ID_URI = config.API_APPLICATION_ID_URI;


export const msalConfig = {
    auth: {
      clientId: config.MSAL_CLIENTID ,
      authority: config.MSAL_AUTHORITY_URL,
      redirectUri: config.REDIRECT_URI,
      postLogoutRedirectUri: window.location.origin,
      navigateToLoginRequestUrl: false, 
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: true, 
      secureCookies: window.location.protocol === "https:",
      claimsBasedCachingEnabled: true,
    },
    system: {
      allowRedirectInIframe: false,
      asyncPopups: false, 
      allowNativeBroker: false,
      windowHashTimeout: 60000,
      iframeHashTimeout: 6000,
      loadFrameTimeout: 0,
      loggerOptions: {
        logLevel: LogLevel.Info,
        loggerCallback: (level, message, containsPii) => {
          if (containsPii) {
            return;
          }
          switch (level) {
            case LogLevel.Error:
              console.error(`MSAL Error: ${message}`);
              return;
            case LogLevel.Info:
              return;
            case LogLevel.Verbose:
              console.debug(`MSAL Verbose: ${message}`);
              return;
            case LogLevel.Warning:
              console.warn(`MSAL Warning: ${message}`);
              return;
          }
        },
        piiLoggingEnabled: false,
      },
    },
};

// Login request configuration
export const loginRequest = {
    scopes: ["User.Read",],
    prompt: "select_account", 
};
export const apiRequest = {
  scopes: [VITE_API_APPLICATION_ID_URI]
}

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};
export const apiMapRequest = {
  scopes: ["https://atlas.microsoft.com/.default"]
}


